import { render, staticRenderFns } from "./mAbout.vue?vue&type=template&id=05ed869a&scoped=true"
import script from "./mAbout.vue?vue&type=script&lang=js"
export * from "./mAbout.vue?vue&type=script&lang=js"
import style0 from "./mAbout.vue?vue&type=style&index=0&id=05ed869a&prod&lang=scss&scoped=true"
import style1 from "./mAbout.vue?vue&type=style&index=1&id=05ed869a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ed869a",
  null
  
)

export default component.exports